import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
// import eng language
import apiErrorsEn from "./en/apiError.json";
import countryEn from "./en/country.json";
import enumEn from "./en/enum.json";
import translationEn from "./en/translation.json";

// import vi language
import apiErrorsVi from "./vi/apiError.json";
import countryVi from "./vi/country.json";
import enumVi from "./vi/enum.json";
import translationVi from "./vi/translation.json";
import { Language } from "../enumeration/language";

export const resources = {
  en: {
    translation: { ...translationEn, ...countryEn, ...enumEn, ...apiErrorsEn },
  },
  vi: {
    translation: { ...translationVi, ...countryVi, ...enumVi, ...apiErrorsVi },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: Language.vi,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
